export const responsiveCalc = (value) => {
  let newValue = (parseInt(value.replace(/^px+/i, "")) / 1239) * 100;
  return `${newValue}vw`;
};
